module.exports = __webpack_public_path__ + "6fa7a945451ec440ccb518e10eb0c741-pipelines_distribution_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/pipelines_distribution_2x.jpg
// module id = 756
// module chunks = 0